import axios from 'axios';
import { FilterModel, StatusChange } from '../Interfaces';
import { getDefaultHeaders } from '../Utils';
import { getStatusChangesEndpoint } from '../Endpoints';

export const getStatusChanges = async (token: string, managementId: string, eventId: number, page?: number, filtering?:FilterModel[]): Promise<{data: StatusChange[], count: number}> => {
    try{
        const {data, status} = await axios.get(getStatusChangesEndpoint(eventId), getDefaultHeaders(token, managementId, page, filtering, "Filter"));
        if (status === 200 && data.Ok){
            const result: StatusChange[] = data.Data;
            return {data: result, count: data.Count};
        }

        return {data: [], count: 0};
    } catch {
        return {data: [], count: 0};
    }
}